import React from "react";

export const Location = props => {
  const { event, timezone } = props;

  return (
    <div>
      <span className='title'>Location:</span>
      &nbsp;
      <span>
        {event.locationName}&nbsp;
        <span className='text-muted'>
            [{timezone.abbr} {timezone.name} {timezone.offsetString}]
          </span>
        </span>
    </div>
  )}
